import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../ui/select';
import type { LedgerView } from '../../types/drawdown';

interface LedgerViewSelectProps {
  value: LedgerView;
  onChange: (view: LedgerView) => void;
}

export function LedgerViewSelect({ value, onChange }: LedgerViewSelectProps) {
  return (
    <Select
      value={value}
      onValueChange={(view) => onChange(view as LedgerView)}
    >
      <SelectTrigger className="w-40 h-8" aria-label="Ledger view">
        <SelectValue placeholder="Status" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all">All Statuses</SelectItem>
        <SelectItem value="approved">Approved & Posted</SelectItem>
        <SelectItem value="posted">Posted</SelectItem>
      </SelectContent>
    </Select>
  );
}
